var map = {
	"./angle down.svg": 90453,
	"./angle left double.svg": 65657,
	"./angle left.svg": 23406,
	"./angle right.svg": 32493,
	"./angle up.svg": 48794,
	"./arrow down.svg": 79135,
	"./arrow left.svg": 37024,
	"./arrow right.svg": 6223,
	"./arrow up.svg": 72592,
	"./bookmark filled.svg": 49166,
	"./bookmark.svg": 33286,
	"./check.svg": 49814,
	"./circle check.svg": 56322,
	"./circle cross.svg": 67794,
	"./circle info.svg": 27954,
	"./circle minus.svg": 20286,
	"./circle plus.svg": 42038,
	"./circle question.svg": 35890,
	"./cross.svg": 19814,
	"./document.svg": 10405,
	"./email.svg": 306,
	"./irrelevant.svg": 57140,
	"./lock.svg": 84319,
	"./minus.svg": 30850,
	"./plus.svg": 23818,
	"./printer.svg": 79546,
	"./question.svg": 11457,
	"./search.svg": 3966,
	"./speech bubble.svg": 94282,
	"./spinner.svg": 39585,
	"./text document.svg": 54498,
	"./trash.svg": 80,
	"./warning.svg": 14898,
	"./word.svg": 28874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81643;